/**
 * Contact Us — i18n text sync only.
 * Map uses a pinned OpenStreetMap iframe (no JS map library).
 */
(function () {
  const root = document.querySelector('[data-bb-contact]');
  if (!root) return;

  const i18nEl = root.querySelector('[data-bb-contact-i18n]');
  if (!i18nEl) return;

  let i18n;
  try {
    i18n = JSON.parse(i18nEl.textContent);
  } catch (e) {
    return;
  }

  function applyLanguage(lang) {
    const pack = i18n[lang];
    if (!pack) return;

    root.setAttribute('data-bb-contact-lang', lang);
    root.setAttribute('lang', lang === 'zh' ? 'zh-Hant-HK' : 'en');

    root.querySelectorAll('[data-bb-contact-text]').forEach(function (el) {
      const key = el.getAttribute('data-bb-contact-text');
      if (pack[key] != null && pack[key] !== '') {
        el.textContent = pack[key];
      }
    });

    const emailLink = root.querySelector('[data-bb-contact-email-link]');
    if (emailLink && pack.email_link) {
      emailLink.setAttribute('href', pack.email_link);
    }

    const mapFrame = root.querySelector('[data-bb-contact-map-label]');
    if (mapFrame && pack.map_label) {
      mapFrame.setAttribute('aria-label', pack.map_label);
      const iframe = mapFrame.querySelector('[data-bb-contact-map-iframe]');
      if (iframe) iframe.setAttribute('title', pack.map_label);
    }
  }

  applyLanguage(root.getAttribute('data-bb-contact-lang') || 'en');
})();
